<template>
  <form-group class="select-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <select ref="primaryInput"
            class="uk-select"
            :class="inputCss"
            v-model="internalValue"
            :disabled="disabled"
            @input="onInput">
      <option v-if="includeBlank" :value="null">{{placeholder}}</option>
      <option v-for="option in options" :value="option.value">
        {{option.label}}
      </option>
      <slot />
    </select>
  </form-group>
</template>

<script>
import InputWithOptions from '@/mixins/InputWithOptions';

export default {
  name: 'select-input',
  mixins: [InputWithOptions],
  props: {
    placeholder: String,
    includeBlank: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// SelectInput.vue?1d91d412